import MiniSelect from "./MiniSelect";
import { SHOT_TYPES, CAMERA_ANGLES, CAMERA_MOVEMENTS, LIGHTING_STYLES, LENS_OPTIONS } from "@/constants/shotSettings";
import { Camera, Video, Aperture, Lightbulb, Move } from "lucide-react";

export default function EquipmentTab({
  shotType, setShotType,
  cameraAngle, setCameraAngle,
  cameraMovement, setCameraMovement,
  lighting, setLighting,
  lens, setLens,
}) {
  return (
    <div className="space-y-2.5">
      <MiniSelect
        options={SHOT_TYPES}
        value={shotType}
        onChange={setShotType}
        label="Shot Type"
        icon={Camera}
      />
      <MiniSelect
        options={CAMERA_ANGLES}
        value={cameraAngle}
        onChange={setCameraAngle}
        label="Camera Angle"
        icon={Video}
      />
      <MiniSelect
        options={CAMERA_MOVEMENTS}
        value={cameraMovement}
        onChange={setCameraMovement}
        label="Camera Movement"
        icon={Move}
      />
      <MiniSelect
        options={LIGHTING_STYLES}
        value={lighting}
        onChange={setLighting}
        label="Lighting"
        icon={Lightbulb}
      />
      <MiniSelect
        options={LENS_OPTIONS}
        value={lens}
        onChange={setLens}
        label="Lens"
        icon={Aperture}
      />
    </div>
  );
}
